import { render, staticRenderFns } from "./CookiesPolicyView.vue?vue&type=template&id=34510786&scoped=true"
import script from "./CookiesPolicyView.vue?vue&type=script&lang=js"
export * from "./CookiesPolicyView.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicyView.vue?vue&type=style&index=0&id=34510786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34510786",
  null
  
)

export default component.exports